<template src="./ModalExportComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {AppConstant} from "@/supports/app.constant";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile.js";
import {ErrorText, SuccessMessageConstant} from "@/supports/error-message.constant.ts";
export default {
  name: 'ModalExportComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    location: {
      type: String,
      required: false,
      default: () => ''
    },
    table: {
      type: String,
      required: false,
      default: () => ''
    },
    listItemSelected: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['showModal'],
  setup(props, { emit }) {
    const errors = ref(true)
    const dataModal = ref({
      file_name: {
        id: 'file_name',
        label: 'Tên file',
        placeholder: 'Tên file',
        value: '',
        required: false,
        disable: false,
      },
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        required: false,
        disable: true,
      },
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        required: false,
        disable: false,
        options: []
      },
      type: {
        id: 'type',
        label: 'Kiểu File',
        placeholder: 'Kiểu File',
        value: '',
        required: false,
        disable: true,
      },
    })
    const clickShowModal = ref(false)
    const accountStore = useAccountStore()
    const settingFormatFileStore = useSettingFormatFileStore()

    // bind event click show modal to call api get list product
    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      clickShowModal.value = eventClickShowModal
      dataModal.value.table_use.value = props.location
      if(clickShowModal.value) {
        getListFormatFile()
      }
      emit('showModal', true)
    })

    watch(() => settingFormatFileStore.settingFormat, (newListSettingFormat) => {
      newListSettingFormat.forEach((item) => {
        dataModal.value.name.options.push({
          name: item.name,
          value: item.id,
        })
      })
    });

    watch(() => dataModal.value.name.value, (newSetting) => {
      const settingSelected = settingFormatFileStore.settingFormat.find(setting => newSetting === setting.id)
      dataModal.value.type.value = CommonService.compareTypeFileLabel(settingSelected.type ?? 0)
    });

    function onChange(value, name) {
      dataModal.value[name].value = value;
    }

    async function getListFormatFile() {
      const params = {
        company_id: accountStore.account.company.id,
        table_use: props.table,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/format-file/format-list';
      await settingFormatFileStore.getListFormatFileWithoutLimit(url, params);
    }

    async function eventFile() {
      for (const item in dataModal.value) {
        validateForm(dataModal.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          company_id: accountStore.account.company.id,
          setting_format_id: dataModal.value.name.value,
          file_name: dataModal.value.file_name.value,
          product_ids: props.listItemSelected,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/format-file/export';
        const res = await settingFormatFileStore.exportFile(url, params);
        const blob = window.URL.createObjectURL(
            new Blob([res.data])
        );
        const link = document.createElement("a");
        link.href = blob;
        link.setAttribute("download", dataModal.value.file_name.value + "." + dataModal.value.type.value);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blob);
        dataModal.value.file_name.value = ''
        dataModal.value.file_name.value = ''
        dataModal.value.type.value = ''
        emit('showModal', false)
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function validateForm(value, name) {
      if(name === 'file_name') {
        dataModal.value.file_name.isError = false;
        dataModal.value.file_name.error = ''
        errors.value = false
        if(!value) {
          dataModal.value.file_name.isError = true;
          dataModal.value.file_name.error = ErrorText.REQUIRED(dataModal.value.file_name.label);
          errors.value = true
        }
      }
    }

    return {
      dataModal,
      onChange,
      eventFile,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modalExport {
  .modal-content {
    background: #ffffff;
  }

  .modal-body {
    .select-form, .input-number {
      width: 172px;
    }
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
